import React, { useCallback, useEffect } from "react"
import { useForm } from "react-final-form"
import { makeStyles } from "@material-ui/core/styles"
import { NumberInput, useListContext, useListFilterContext } from "react-admin"

const useStyles = makeStyles({
  filter: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
  },
  input: {
    marginRight: "0.5em",
  },
})

interface NumberRangeFilterProps {
  source: string
  label: string
}

export function NumberRangeFilter (props: NumberRangeFilterProps) {
  const { source, label } = props
  const form = useForm()
  const classes = useStyles()

  const minSource = `${source}__gte`
  const maxSource = `${source}__lte`

  const handleMinChange = useCallback(
    (eventOrValue) => {
      const value = eventOrValue.target
        ? eventOrValue.target.value : eventOrValue
      form.change(minSource, Number(value))
    },
    [form, minSource],
  )

  const handleMaxChange = useCallback(
    (eventOrValue) => {
      const value = eventOrValue.target
        ? eventOrValue.target.value : eventOrValue
      form.change(maxSource, Number(value))
    },
    [form, maxSource],
  )

  return (
    <div className={classes.filter}>
      <NumberInput
        label={`Min ${label}`}
        source={minSource}
        onChange={handleMinChange}
        type="number"
        className={classes.input}
        helperText={false}
      />
      <NumberInput
        label={`Max ${label}`}
        source={maxSource}
        onChange={handleMaxChange}
        type="number"
        className={classes.input}
        helperText={false}
      />
    </div>
  )
}

export function NumberRangeFilterWithField (props: NumberRangeFilterProps) {
  return <NumberRangeFilter {...props} />
}
